import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomClarityModule } from 'src/app/custom.clarity.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ValidationMessageComponent } from 'src/app/validation-message/validation.message';

@NgModule({
    imports: [CommonModule, CustomClarityModule, FormsModule, ReactiveFormsModule],
    declarations: [ValidationMessageComponent],
    exports: [CustomClarityModule, FormsModule, ReactiveFormsModule, ValidationMessageComponent]
})

export class CustomerSharedModule{}
